module.exports = __webpack_public_path__ + "img/banner-En.35fac89f.png";